module.exports = __webpack_public_path__ + "img/selected4-min.ccbd8b17.png";